import { transformWidgetProps } from '@/components/WidgetMaker/utils/common';
import Dialog from '@mui/material/Dialog';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormCFEComponent from '../common/FormCFEComponent';
import FormCompletion from '../common/FormCompletion';

const ModernFormDesktop = (props) => {
  const { open, handleClose } = props;
  const storeData = useSelector((state) => state.storeReducer.store);
  const themeFormConfig = storeData?.theme?.components?.Body?.filter(
    (comp) => comp.sub_type === 'Form'
  );
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [formConfig, setFormConfig] = useState(null);
  const [transformedState, setTransfomedState] = useState({});

  useEffect(() => {
    if (themeFormConfig && themeFormConfig?.length > 0) {
      setFormConfig(themeFormConfig[0]);
    }
  }, [themeFormConfig]);

  useEffect(() => {
    setTransfomedState(transformWidgetProps(formConfig?.config?.children));
  }, [formConfig]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          width: 400,
        },
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {isFormSubmit ? (
        <FormCompletion onClose={handleClose} />
      ) : (
        <FormCFEComponent
          heading={transformedState?.heading?.text || ''}
          description={transformedState?.description?.text || ''}
          buttonText={
            transformedState.button ? transformedState.button.content[0].btnText : ''
          }
          buttonConfig={transformedState.button ? transformedState.button : null}
          storeData={storeData}
          widgetId={formConfig?.widget_id}
          toggleFormCompletion={setIsFormSubmit}
          onClose={handleClose}
          open={open}
        />
      )}
    </Dialog>
  );
};

export default ModernFormDesktop;
